// ──────────────────────────────────────────────────────────────
// 월 혜택 금액 합산 — 단일 진실 공급원(single source of truth)
//
// 사용자가 가장 민감하게 보는 "이번 달 받을 수 있는 금액". 특수 분기가 많아
// 금액 오류가 나기 쉬운 곳이라 모듈로 분리 + 회귀 테스트(scripts/test-benefitAmount.js)로 박제.
//   · 부모급여(id:5): 만0세 100만, 만1세 50만 (자녀별 분기)
//   · 아동수당(id:7): 수도권 10만 / 비수도권 13만 × 만9세 미만 자녀 수
//   · 한부모 아동양육비(id:302): b.n(23만, 2026 기본액) × 만18세 미만 자녀 수 (5세이하 미혼모·조손·청년한부모 +10만은 조건부라 미반영)
//   · 그 외 mC 월지급: 매칭 자녀 수만큼 b.n 합산
//   · 가족 단위(mF): b.n 1회 합산
// age(나이)는 dateUtils 공유. 테스트 위해 기준시각(now) 선택 인자 지원.
// (2026-06-18 모듈화 4단계)
// ──────────────────────────────────────────────────────────────
const { age } = require("./dateUtils");

function monthlyAmount(bs, u, now) {
  // 상호배타 — 보육료(id:8)·유아학비(id:9)·가정양육수당(id:52)은 한 아이가 셋 중 하나만 수급(기관 중복 불가).
  // 큰 순(8>9>52)으로 하나만 합산해 과대표시 방지. 매칭 목록에는 전부 표시(자격 안내). (2026-07-03 전수QA)
  const _ids = new Set((bs || []).map((b) => b && b.id));
  const _skipCare = new Set(_ids.has(8) ? [9, 52] : _ids.has(9) ? [52] : []);
  return (bs || []).reduce((t, b) => {
    if (!b || b.tp !== "월지급") return t;
    if (_skipCare.has(b.id)) return t;
    // 부모급여 (id:5) — 자녀 연령별 분기
    if (b.id === 5 && u && u.children && u.children.length) {
      return t + u.children.reduce((sum, c) => {
        const a = age(c.birthDate, now);
        if (a === 0) return sum + 1e6;   // 만0세 100만원
        if (a === 1) return sum + 5e5;   // 만1세 50만원
        return sum;
      }, 0);
    }
    // 아동수당 (id:7) — 수도권 10만, 비수도권 13만 × 만9세 미만 자녀 수
    if (b.id === 7 && u && u.children && u.children.length) {
      const isNonMetro = u.city && !/서울특별시|경기도|인천광역시/.test(u.city);
      const perChild = isNonMetro ? 13e4 : 1e5;
      const eligibleCount = u.children.filter((c) => { const a = age(c.birthDate, now); return a >= 0 && a < 9; }).length;
      return t + eligibleCount * perChild;
    }
    // 한부모가족 아동양육비 (id:302) — 만18세 미만 자녀 수만큼
    if (b.id === 302 && u && u.children && u.children.length) {
      const cnt = u.children.filter((c) => { const a = age(c.birthDate, now); return a >= 0 && a < 18; }).length;
      return t + (b.n || 0) * cnt;
    }
    // 그 외 자녀 매칭(mC) 월지급 — 매칭 자녀 수만큼 합산
    if (b.mC && u && u.children && u.children.length && b.n > 0) {
      const eligibleCount = u.children.filter((c) => { try { return b.mC(c); } catch (e) { return false; } }).length;
      return t + b.n * eligibleCount;
    }
    // 가족 단위 (mF) — 1번만 합산
    return t + (b.n || 0);
  }, 0);
}

module.exports = { monthlyAmount };
